<template>
  <div class="flights-search">
    <div class="relative rounded-2xl h-[525px] lg:h-[426px] flex flex-col justify-end">
      <img src="/images/banner-cala-ibiza.webp" alt="Vista desde el cielo de una cala en Ibiza" class="h-full object-cover">
      <div class="floating-container">
        <h1 class="heading-1 text-white">{{ $t('searcher.trip_more_days') }}</h1>
        <app-searcher-wrapper class="mt-5">
          <div class="search-card">
            <app-search-form-more-days :searchType="searchType"></app-search-form-more-days>
          </div>
        </app-searcher-wrapper>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import prependCustomIcons from '../../utils/mixins/prependCustomIcons';
import replaceArrows from '../../utils/mixins/replaceArrows';
import SearcherWrapper from './components/SearcherWrapper.vue';

export default {
  mixins: [prependCustomIcons, replaceArrows],
  components: {
    'app-searcher-wrapper': SearcherWrapper
  },
  data: () => ({
    searchType: 2,
  }),
  methods: {
    handleSearchTypeButton(value) {
      this.searchType = value;
      this.$nextTick(() => {
        this.prependCustomIcons();
        this.replaceArrows();
      });
    }
  },
};
</script>

<style lang="scss">
</style>
